/**
 *
 * @module serviceClientConfiguration
 *
 */

/**
 *
 * @class serviceClientConfiguration
 * @desc A model containing service client configuration settings.
 *
 */
export default class ServiceClientConfiguration {

    /**
     *
     * @param {String} baseUrl
     * @param {Object} [endpoints={}]
     *
     */
    constructor(baseUrl, endpoints = {}) {

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.baseUrl = baseUrl;

        /**
         *
         * @access public
         * @type {Object}
         *
         */
        this.endpoints = endpoints;

    }

}



// WEBPACK FOOTER //
// ./src/services/configuration/serviceClientConfiguration.js